import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { OTHER_INTEGRATIONS } from 'services/consts';

const initialState = {
	integrationsStores: []
};

export const getIntegrationsList = createAsyncThunk('integration/fetchAll', async (_, { getState }) => {
	const { integrationsStores } = getState();
	if (integrationsStores.length > 0) {
		return integrationsStores;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(OTHER_INTEGRATIONS.GET_INTEGRATIONS);

	return response.data;
});

const integrationsStores = createSlice({
	name: 'integrationsStores',
	initialState,
	reducers: {
		setConnectedIntegrations: (state, { payload }) => [...payload],
		updateConnectedIntegration: (state, { payload }) => {
			const index = state.findIndex((item) => item.smsConfigID === payload.smsConfigID);
			state[index].status = payload.status;
			state[index].configName = payload.configName;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(getIntegrationsList.fulfilled, (state, { payload }) => {
			state.integrationsStores = payload;
		});
	}
});

export const { setConnectedIntegrations, updateConnectedIntegration } = integrationsStores.actions;

export default integrationsStores.reducer;
